import GModalHeader from "glesys-controlpanel/components/g-modal/header";
import GModalBody from "glesys-controlpanel/components/g-modal/body";
import GModalFooter from "glesys-controlpanel/components/g-modal/footer";
import GButton from "glesys-controlpanel/components/g-button";
import TaskForm from "glesys-controlpanel/components/task-form";
import IconsInfo from "glesys-controlpanel/components/icons/info";
import Label from "glesys-controlpanel/components/label";
import Copyable from "glesys-controlpanel/components/copyable";
import modalClose from "glesys-controlpanel/helpers/modal-close";
import { t } from "ember-intl";
import { on } from "@ember/modifier";

<template>
  <GModalHeader>
    {{t "component.modal.email-account-reset-password.title" account=@params.account.id}}
  </GModalHeader>
  <GModalBody>
    <TaskForm id="email-account-reset-password" @task={{@params.task}}>
      {{#if @params.task.lastSuccessful}}
        <div class="grid gap-6">
          <div class="bg-gray-50 border border-gray-200 p-4 rounded-sm inline-block">
            <p class="font-bold text-sm text-gray-500 flex items-center mb-1">
              <IconsInfo class="w-4 mr-2 stroke-gray-400" />
              <span>{{t "label.please-note"}}</span>
            </p>
            <p class="text-sm text-gray-800 pl-6 pr-4">
              {{t "component.modal.email-account-reset-password.store-password-reminder"}}
            </p>
          </div>
          <div>
            <Label class="mb-0.5">
              {{t "label.password"}}
            </Label>
            <Copyable
              class="text-black text-lg font-mono block"
              data-test-email-account-reset-password-generated-password
            >
              {{@params.task.lastSuccessful.value.password}}
            </Copyable>
          </div>
        </div>
      {{else}}
        <p class="text-gray-800 text-md pb-4">
          {{t "component.modal.email-account-reset-password.password-will-be-generated" account=@params.account.id}}
        </p>
      {{/if}}
    </TaskForm>
  </GModalBody>
  <GModalFooter>
    <GButton class="mr-2" @color="gray" {{on "click" (modalClose)}}>
      {{t "button.close"}}
    </GButton>
    <GButton
      data-test-email-account-reset-password-button
      @type="submit"
      @color="blue"
      form="email-account-reset-password"
    >
      {{t "button.reset-password"}}
    </GButton>
  </GModalFooter>
</template>
